export default __webpack_public_path__ + "static/media/success-mini.89c25c23.svg";